
import { useState } from 'react';
import { Container, Title, Content } from './styled';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

export function OptionMenu(props) {

  const { title, children } = props;
  const [isHidden, setIsHidden] = useState(false);

  return (
    <Container>
      <Title onClick={() => setIsHidden(!isHidden)} isHidden={isHidden}>
        <div>
          {title}
        </div>
        {isHidden ? <BiChevronDown className='icon' /> : <BiChevronUp className='icon' />}
      </Title>
      <Content isHidden={isHidden}>
        {children}
      </Content>
    </Container>
  );
}